import PropTypes from "prop-types";
import { TYPE_IMAGE, TYPE_TEXT } from "../../../../stores/overleaf-store";

const metadataPropTypes = {
  image: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    title: PropTypes.string
  }),
  text: PropTypes.shape({})
};

export const cardContentPropTypes = PropTypes.shape({
  content: PropTypes.string.isRequired,
  type: PropTypes.oneOf([TYPE_IMAGE, TYPE_TEXT]).isRequired,
  metadata: PropTypes.oneOfType([
    metadataPropTypes.image,
    metadataPropTypes.text
  ]).isRequired
});

export const cardPropTypes = PropTypes.shape({
  front: cardContentPropTypes.isRequired,
  back: cardContentPropTypes.isRequired
});

export function getEmptyCard() {
  return {
    type: TYPE_TEXT,
    content: "",
    metadata: {}
  };
}
